import { render, staticRenderFns } from "./UserOrderExtend.vue?vue&type=template&id=d641c14a&"
import script from "./UserOrderExtend.vue?vue&type=script&lang=js&"
export * from "./UserOrderExtend.vue?vue&type=script&lang=js&"
import style0 from "./UserOrderExtend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports